export const isTicketSnoozed = (ticket, now = Date.now()) => {
  if (!ticket?.snoozedUntil) return false;

  return new Date(ticket.snoozedUntil).getTime() > now;
};
